/**
 * 营销活动站点展示：sites 为空表示不限制站点（ALL）。
 */

const ALL_LABEL = 'ALL';

function parseRawSites(rawJson) {
  if (rawJson == null || rawJson === '') return null;
  try {
    const raw = typeof rawJson === 'string' ? JSON.parse(rawJson) : rawJson;
    if (!raw || typeof raw !== 'object') return null;
    if (!Object.prototype.hasOwnProperty.call(raw, 'sites')) return null;
    if (!Array.isArray(raw.sites)) return [];
    return raw.sites
      .map((s) => String(s?.siteName || '').trim())
      .filter(Boolean);
  } catch {
    return null;
  }
}

function splitSitesText(text) {
  return String(text || '')
    .replace(/…|\.{3}$/g, '')
    .split(/[、,，]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

function isAllSitesMarker(value) {
  const t = String(value || '').trim();
  if (!t) return true;
  const lower = t.toLowerCase();
  return (
    lower === 'all'
    || t === '全部'
    || t === '全部站点'
    || t === '不限制站点'
  );
}

/**
 * @param {object} row 列表/详情行（sites / sitesFull / sitesAll / rawJson）
 * @param {{ maxVisible?: number }} [opts]
 * @returns {{ isAll: boolean, label: string, title: string }}
 */
export function formatMarketingSites(row, opts = {}) {
  const maxVisible = Number.isFinite(opts.maxVisible) && opts.maxVisible > 0 ? opts.maxVisible : 4;
  const fromRaw = parseRawSites(row?.rawJson);

  let names;
  let knownEmptyAll = false;

  if (fromRaw != null) {
    names = fromRaw;
    knownEmptyAll = fromRaw.length === 0;
  } else if (row?.sitesAll === true || isAllSitesMarker(row?.sites) || isAllSitesMarker(row?.sitesFull)) {
    return { isAll: true, label: ALL_LABEL, title: ALL_LABEL };
  } else {
    const fullText = row?.sitesFull || row?.sites || '';
    if (!String(fullText).trim()) {
      return { isAll: true, label: ALL_LABEL, title: ALL_LABEL };
    }
    names = splitSitesText(fullText);
    knownEmptyAll = names.length === 0;
  }

  if (knownEmptyAll || !names.length) {
    return { isAll: true, label: ALL_LABEL, title: ALL_LABEL };
  }

  const title = names.join('、');
  const label = names.length > maxVisible
    ? `${names.slice(0, maxVisible).join('、')}…`
    : title;
  return { isAll: false, label, title };
}

/**
 * checkStatus: 1 符合 / 0 不符合 / 2 报名时检测 / 3 报名页面已自动过滤
 */
export function marketingCheckStatusTone(checkStatus, checkStatusDesc) {
  const code = checkStatus == null || checkStatus === '' ? NaN : Number(checkStatus);
  if (code === 1) return 'pass';
  if (code === 0) return 'fail';
  if (code === 2) return 'pending';
  if (code === 3) return 'filtered';

  const text = String(checkStatusDesc || '').trim();
  if (!text) return 'neutral';
  if (text.includes('不符合') || text.includes('不合格')) return 'fail';
  if (text === '符合' || (text.includes('合格') && !text.includes('不合格'))) return 'pass';
  if (text.includes('报名时检测')) return 'pending';
  if (text.includes('自动过滤')) return 'filtered';
  return 'neutral';
}
